module.exports = __webpack_public_path__ + "img/icon4.488985b2.png";